import { useLayoutEffect, useRef, useState } from 'react';

import { FORTUNES, FORTUNE_COOKIE_IMAGE } from './content';
import * as styles from './FortuneCookie.css';

function pickFortune(previous: number | null): number {
  if (previous === null) {
    return 0;
  }

  let next = Math.floor(Math.random() * FORTUNES.length);
  while (next === previous) {
    next = Math.floor(Math.random() * FORTUNES.length);
  }

  return next;
}

export const FortuneCookie = () => {
  const [fortuneIndex, setFortuneIndex] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState(0);
  const textRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    setWidth(open && fortuneIndex !== null ? (textRef.current?.offsetWidth ?? 0) : 0);
  }, [open, fortuneIndex]);

  const reveal = () => {
    setFortuneIndex((previous) => pickFortune(previous));
    setOpen(true);
  };

  const hide = () => setOpen(false);

  return (
    <button
      type="button"
      className={styles.cookie}
      aria-label="Open a fortune cookie"
      onMouseEnter={reveal}
      onMouseLeave={hide}
      onFocus={reveal}
      onBlur={hide}
      onClick={() => (open ? hide() : reveal())}
    >
      <img
        className={styles.image}
        src={FORTUNE_COOKIE_IMAGE.src}
        width={FORTUNE_COOKIE_IMAGE.width}
        height={FORTUNE_COOKIE_IMAGE.height}
        alt=""
      />
      <span className={styles.fortune} data-open={open} style={{ width }} aria-live="polite">
        <span ref={textRef} className={styles.fortuneText}>
          {fortuneIndex === null ? '' : FORTUNES[fortuneIndex]}
        </span>
      </span>
    </button>
  );
};
